import cx from 'classnames';
import { useRef } from 'react';

import { getRandomString } from 'lib/util';

import { Text } from 'components/typography';

import RadioProps from './Radio.props';

const Radio = ({
  label,
  checked,
  onChange,
  value,
  name,
  id
}: RadioProps): React.ReactNode => {
  const idRef = useRef(getRandomString());
  const inputId = id || idRef.current;
  const classNames = {
    inputClasses: 'h-4 w-4 rounded-full border-white lg-tui:p-[1.875rem]',
    checkedClasses:
      "after:visible after:relative after:left-0 after:top-0 after:block after:h-4 after:rounded-[15px] after:border-thin after:border-solid after:border-red-700 after:bg-red-700 after:text-red-700 after:shadow-[inset_0_0_0_1px_white] after:content-['']"
  };

  return (
    <div className="flex items-center">
      <input
        type="radio"
        checked={checked}
        name={name}
        onChange={onChange}
        value={value}
        id={inputId}
        className={cx(
          classNames.inputClasses,
          checked && classNames.checkedClasses
        )}
      />

      {label && (
        <Text
          size="m"
          tagName="label"
          className="pl-2"
          {...{ htmlFor: inputId, id: `label-${inputId}` }}
        >
          {label}
        </Text>
      )}
    </div>
  );
};

export default Radio;
